// Un nuevo comienzo — treść (po polsku). Long-form sales page.

export const LINKS = {
  checkout: "https://buy.stripe.com/00w28keirfrDgXZbzr7Vm0b",
  buy: "https://buy.stripe.com/00w28keirfrDgXZbzr7Vm0b",
  site: "https://agaespanol.com",
  download: "https://drive.google.com/drive/folders/1eEsQWiNvblIf4IC31W33RITm482Yx7N1",
};

export const IMAGES = {
  cover: {
    src: "https://agaespanol.com/wp-content/uploads/2026/07/Diseno-sin-titulo-61.png",
    fb: "https://static.prod-images.emergentagent.com/jobs/4253cb65-2325-4016-95c4-b6a5e87d9395/images/ec2183a7bd3d6de8b5146ae2fd87d5a034f9009ece578d30821a9670cdb0ca88.jpeg",
  },
  chapter1: {
    src: "https://agaespanol.com/wp-content/uploads/2026/07/Diseno-sin-titulo-58.png",
    fb: "https://static.prod-images.emergentagent.com/jobs/4253cb65-2325-4016-95c4-b6a5e87d9395/images/aa85136392eb64b285b1d3abe8c7dd066f560c7dc06bfbdd784828818e60122c.jpeg",
  },
  author: {
    src: "https://agaespanol.com/wp-content/uploads/2026/07/Diseno-sin-titulo-62.png",
    fb: "https://static.prod-images.emergentagent.com/jobs/4253cb65-2325-4016-95c4-b6a5e87d9395/images/fce67c430d04656575eafa398337e893885d7c0256d067c7d385ff03ac3ac587.jpeg",
  },
  inside: [
    {
      src: "https://agaespanol.com/wp-content/uploads/2026/07/texto1.png",
      fb: "https://static.prod-images.emergentagent.com/jobs/4253cb65-2325-4016-95c4-b6a5e87d9395/images/aa85136392eb64b285b1d3abe8c7dd066f560c7dc06bfbdd784828818e60122c.jpeg",
      alt: "Strona powieści z podświetlonym słownictwem",
      label: "tekst + słowniczek",
    },
    {
      src: "https://agaespanol.com/wp-content/uploads/2026/07/ejercicio1.png",
      fb: "https://static.prod-images.emergentagent.com/jobs/4253cb65-2325-4016-95c4-b6a5e87d9395/images/9eac740d872f5579388ebe6a5129e581fe8a3897b69f0a51bc004b5f577ff231.jpeg",
      alt: "Słowniczek na marginesie i ciekawostka o Hiszpanii",
      label: "Uzupełnij",
    },
    {
      src: "https://agaespanol.com/wp-content/uploads/2026/07/ejercicio-2.png",
      fb: "https://static.prod-images.emergentagent.com/jobs/4253cb65-2325-4016-95c4-b6a5e87d9395/images/74b50a932034981512c0280283db39fb57c6ef53acf846e4e10e174be6843e27.jpeg",
      alt: "Ćwiczenia do rozdziału",
      label: "Przetłumacz",
    },
  ],
};

export const onImgErr = (e, fb) => {
  if (fb && e.currentTarget.src !== fb) e.currentTarget.src = fb;
};

export const MARQUEE = [
  "Prawdziwy język",
  "Audiobook",
  "Tłumaczenie na polski",
  "Praktyczne ćwiczenia",
  "Hiszpańskie ciekawostki",
  "Zero chaosu",
];

// Sekcja-mit (wyróżniony manifest)
export const MYTH = {
  body: [
    "Większość osób robi ten sam błąd: miesiącami wkuwa listy słówek, zanim w ogóle odważy się sięgnąć po książkę. A przecież nasz mózg uczy się z kontekstu, a nie z nudnych regułek.",
    "Dzięki prostej metodzie i odpowiedniej strukturze możesz czytać i rozumieć prawdziwy hiszpański już na poziomie A1/A2. Bez frustracji, bez ciągłego zaglądania do słownika i bez blokady.",
  ],
};

// „Czy masz tak, że…”
export const PAINS = [
  "Uczysz się od dawna, a hiszpański wciąż nie chce wejść do głowy?",
  "Uczysz się słówek, ale kiedy chcesz coś powiedzieć, w głowie masz tylko pustkę?",
  "Znasz zasady gramatyczne, jednak w prawdziwej rozmowie nagle brakuje Ci słów?",
  "Gubisz się, kiedy native speakerzy mówią szybko i naturalnie, chociaż w podręczniku wszystko było jasne?",
  "Wracasz do tych samych regułek po raz kolejny, bo za każdym razem coś wymyka się z pamięci?",
  "Marzysz o tym, żeby czytać po hiszpańsku z przyjemnością, a nie ze słownikiem w ręku?",
];

// Historia autorki (długa, emocjonalna, zorientowana na korzyści ucznia)
export const STORY = [
  "Zanim zaczęłam uczyć, sama byłam po drugiej stronie. Godziny nad podręcznikami, listy słówek, regułki — a i tak, kiedy przychodziło do prawdziwej rozmowy, słowa gdzieś uciekały. Doskonale znam to uczucie.",
  "Skończyłam licencjat z filologii hiszpańskiej, studia w Hiszpanii oraz magisterkę z nauczania hiszpańskiego jako języka obcego. Jednak najwięcej daje mi samo życie: od 8 lat mieszkam w Hiszpanii, a hiszpański to mój codzienny język — rozmawiam w nim w domu, czytam książki, oglądam filmy i seriale. Mam ciągły, żywy kontakt z językiem dokładnie takim, jakim ludzie posługują się na co dzień: na ulicy, w kawiarni czy wśród znajomych.",
  "Od lat uczę Polaków i wiem, co naprawdę działa. Pomagam przełamywać blokadę w mówieniu, rozumieć szybko mówiących Hiszpanów i w końcu poczuć, że ten język jest naprawdę Twój.",
  "Książkę „Un nuevo comienzo” napisałam właśnie dla Ciebie — żeby nie czekać do poziomu B2, by poczuć radość z czytania po hiszpańsku. Chcę, żeby od pierwszego rozdziału towarzyszył Ci żywy język — i żeby nauka wreszcie sprawiała Ci prawdziwą przyjemność.",
];

export const CREDENTIALS = [
  { t: "Wykształcenie kierunkowe", d: "Licencjat z filologii hiszpańskiej oraz studia w Hiszpanii." },
  { t: "Magisterka z nauczania", d: "Specjalizacja: nauczanie hiszpańskiego jako języka obcego (ELE)." },
  { t: "8 lat życia w Hiszpanii", d: "Mieszkałam w różnych wspólnotach autonomicznych i używam hiszpańskiego na co dzień." },
  { t: "Lata doświadczenia z uczniami", d: "Dziesiątki uczennic i uczniów z bardzo dobrymi, realnymi efektami." },
];

// „O co chodzi w tym projekcie?”
export const PRODUCT = {
  lead: "„Un nuevo comienzo” to nie kolejny nudny podręcznik. To wciągająca powieść napisana specjalnie dla Ciebie, jeśli uczysz się hiszpańskiego na poziomie A1/A2.",
  body: [
    "Czeka na Ciebie żywy język, którym naprawdę mówi się w Hiszpanii, a nie odrealnione listy słówek. Bez chaosu i bez szukania materiałów po całym internecie. Dostajesz jedną, spójną ścieżkę, która krok po kroku prowadzi Cię do pewności siebie i płynności w mówieniu.",
    "Śledzisz historię Lucii z Walencji oraz jej tajemniczej pocztówki. Przy okazji, zupełnie niechcący, oswajasz ucho i głowę z prawdziwym hiszpańskim.",
  ],
};

export const INCLUDES = [
  { icon: "BookOpen", n: "01", t: "Powieść w 30 rozdziałach", d: "Jedna wciągająca historia z tajemniczą pocztówką w tle. Krótkie rozdziały, żywy język i mnóstwo naturalnych zwrotów.", img: 0 },
  { icon: "Headphones", n: "02", t: "Audiobook", d: "Nagrany przez rodowitą Hiszpankę, z opcją regulacji prędkości. Oswajasz ucho z tym, jak Hiszpanie mówią na co dzień.", img: 1 },
  { icon: "Languages", n: "03", t: "Pełne tłumaczenie na polski", d: "Znajdziesz je na końcu książki, żeby szybko rozwiać każdą wątpliwość bez szukania słówek w internecie.", img: 2 },
  { icon: "CircleCheckBig", n: "04", t: "Ćwiczenia z kluczem odpowiedzi", d: "Do każdego rozdziału, żeby od razu sprawdzić swoje postępy. Klucz odpowiedzi znajdziesz na końcu książki.", img: 0 },
  { icon: "CalendarDays", n: "05", t: "Kalendarz czytania", d: "Gotowy plan na 30 dni, dzięki któremu wpadasz w stały rytm: jeden rozdział dziennie.", img: 1 },
  { icon: "Globe2", n: "06", t: "Ciekawostki o Hiszpanii + wersja do druku", d: "Poznajesz kulturowy klimat kraju, a nie tylko sam język. A jeśli wolisz papier, masz gotowy plik do druku.", img: 2 },
  { icon: "FileText", n: "07", t: "Interaktywny plik PDF", d: "Wypełniaj ćwiczenia i wpisuj odpowiedzi bezpośrednio na tablecie, telefonie lub komputerze — bez konieczności drukowania!", img: 0 },
];

// „Unikalna metoda” — 5 kroków
export const METHOD = [
  { t: "Czytasz", d: "Krótki rozdział wciąga Cię w historię Lucii i po prostu chcesz wiedzieć, co wydarzy się dalej." },
  { t: "Słuchasz", d: "Włączasz nagranie i oswajasz ucho z żywym, naturalnym hiszpańskim." },
  { t: "Rozumiesz w kontekście", d: "Słowniczek na marginesie oraz pełne tłumaczenie wyjaśniają wszystko bez szukania w internecie." },
  { t: "Ćwiczysz", d: "Krótkie zadania pozwalają utrwalić nowe słowa i zwroty, a odpowiedzi sprawdzasz na końcu książki." },
  { t: "Powtarzasz", d: "Te same wyrażenia wracają naturalnie w kolejnych rozdziałach, dając efekt kuli śnieżnej." },
];

// „Co konkretnie zyskasz?”
export const BENEFITS = [
  { t: "Przeczytasz swoją pierwszą powieść po hiszpańsku", d: "Bez czekania na poziom B2. Od pierwszego tygodnia obcujesz z prawdziwą historią zamiast sztucznych zdań z podręcznika." },
  { t: "Zaczniesz rozumieć żywy, codzienny język", d: "Poznasz zwroty, których Hiszpanie naprawdę używają na co dzień, w tym popularne wyrażenia potoczne." },
  { t: "Łatwiej zrozumiesz szybko mówiących Hiszpanów", d: "Dzięki audiobookowi wytrenujesz ucho i przestaniesz się gubić, gdy ktoś mówi z naturalną prędkością." },
  { t: "Poczujesz, że gramatyka wreszcie ma sens", d: "Zobaczysz ją w akcji, w realnych sytuacjach. Zamiast wkuwać reguły, wyczujesz je intuicyjnie." },
  { t: "Wejdziesz w stały nawyk bez zmuszania się", d: "Wciągająca historia sprawia, że czytasz z ciekawością, a nauka dzieje się sama przy okazji." },
];

export const PATHS = {
  a: {
    t: "Pierwsza droga",
    d: "Nie zmieniasz nic. Twój hiszpański stoi w miejscu, dalej wkuwasz listy słówek, a myśl o czytaniu po hiszpańsku wciąż odkładasz „na kiedyś, gdy będę na wyższym poziomie”.",
  },
  b: {
    t: "Druga droga",
    d: "Decydujesz się na małą inwestycję z ogromnym efektem. Od pierwszego tygodnia czytasz prawdziwą historię, oswajasz ucho, a hiszpański z ulicy zaczyna wchodzić do głowy sam — z przyjemnością, nie z przymusu.",
  },
};

export const PRICE_ITEMS = [
  "Powieść w 30 rozdziałach (żywy hiszpański A1/A2)",
  "Audiobook nagrany przez rodowitą Hiszpankę",
  "Ćwiczenia z kluczem odpowiedzi",
  "Pełne tłumaczenie na polski",
  "Kalendarz czytania na 30 dni",
  "Ciekawostki o Hiszpanii + wersja do druku",
  "Dostęp bezterminowy",
];

export const TESTIMONIALS = [
  { n: "Dona Piekarczyk", m: "Komentarz na Facebooku", t: "Bardzo mi się podoba. Piękna praca. Jak dla mnie super materiał do nauki.", r: "💛 🙏" },
  { n: "Małgorzata Przybył", m: "Komentarz na Facebooku", t: "Polecam! Rozdział świetnie obudowany metodycznie. Sprawdzi się jako wsparcie dla tych, którzy z hiszpańskim mieli już styczność…", r: "👍" },
  { n: "Katarzyna W.", m: "Wiadomość na Instagramie", t: "Pierwszy raz czytam po hiszpańsku i nie odpuszczam po jednej stronie. Historia naprawdę wciąga!", r: "❤️ 🔥" },
];

// Zrzuty ekranu opinii (jasne). Slider poziomy.
export const TESTIMONIAL_SHOTS = [
  "https://customer-assets-jai6qajn.emergentagent.net/job_lucy-story-preview/artifacts/e9m127yj_49391500-4655-4286-b833-029af9e1bb5f.jpg",
  "https://customer-assets-jai6qajn.emergentagent.net/job_lucy-story-preview/artifacts/a9gqnrqv_22df4ef8-5e74-4adf-9ac9-84f2a378120d.jpg",
  "https://customer-assets-jai6qajn.emergentagent.net/job_lucy-story-preview/artifacts/emvrh9d8_d750479b-2e34-44d0-9e2b-34a830623281.jpg",
  "https://customer-assets-jai6qajn.emergentagent.net/job_lucy-story-preview/artifacts/b29r67zr_2ac2bbaf-e80f-4058-b4ef-8a089a0e730a.jpg",
];

export const FOR_YOU = [
  "Chcesz w końcu ruszyć z miejsca na poziomie A1/A2.",
  "Masz opanowane podstawy i chcesz obcować z żywym, naturalnym językiem.",
  "Chcesz osłuchać się z czystą akcentowo wymową i lepiej rozumieć ze słuchu dzięki audiobookowi nagranemu przez profesjonalną hiszpańską lektorkę.",
  "Masz dość wkuwania słówek na pamięć i szukasz przyjemniejszej metody.",
  "Marzysz o czytaniu po hiszpańsku z przyjemnością, a nie ze słownikiem w ręku.",
  "Wracasz do nauki po przerwie i potrzebujesz czegoś, co naprawdę Cię wciągnie.",
];

export const NOT_FOR_YOU = [
  "Dopiero zaczynasz od zera i nie znasz jeszcze zupełnie nic po hiszpańsku.",
  "Poziom językowy w pełni Ci odpowiada i nie masz potrzeby niczego zmieniać.",
  "Szukasz „magicznych metod” i oczekujesz, że język sam wejdzie do głowy bez Twojego zaangażowania.",
  "Nie zależy Ci na praktycznym, codziennym języku, tylko na akademickich regułkach.",
];

export const FAQ = [
  { q: "Dla kogo jest ta książka?", a: "Dla osób na poziomie A1/A2 (i ambitnych A1+), które znają podstawy i chcą w końcu poczuć się pewniej, czytając prawdziwą historię zamiast kolejnego podręcznika." },
  { q: "Nie mam dużo czasu na naukę, dam radę?", a: "Tak. Rozdziały są krótkie, a kalendarz czytania rozkłada materiał na 30 dni, więc wystarczy 15 do 20 minut dziennie." },
  { q: "Co jeśli utknę na jakimś słowie lub zdaniu?", a: "Masz słowniczek na marginesie każdej strony, ćwiczenia z kluczem odpowiedzi i pełne tłumaczenie na polski na końcu książki." },
  { q: "Jak otrzymam materiały po zakupie?", a: "Po zaksięgowaniu płatności wyślę Ci e-mailem dostęp do e-booka i audiobooka." },
  { q: "Na jak długo otrzymuję materiały?", a: "Dostęp jest bezterminowy, więc materiały są Twoje na zawsze." },
  { q: "Czy otrzymam fakturę?", a: "Tak, fakturę wysyłam mailowo razem z dostępem do materiałów." },
];

// Preventa: 9 sierpnia 2026, 23:59:59 CEST (UTC+2). Klub startuje 10 sierpnia (poniedziałek).
export const SALE_END = "2026-08-09T23:59:59+02:00";
